import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../../constants/routes'
import AdminUsersView from './view'
import AdminUsersList from './list'
import AdminUsersCreate from './create'

const AdminUsersIndex = () => {
    return (
        <>
            <Routes>
                <Route path={nestedRoutePath(routes.adminUsersIndex.path, routes.adminUsersView.path, true)} element={<AdminUsersView />} />
                <Route path={nestedRoutePath(routes.adminUsersIndex.path, routes.adminUsersCreate.path, true)} element={<AdminUsersCreate />} />
                <Route index element={<AdminUsersList />} />
            </Routes>
        </>
    )
}

export default AdminUsersIndex
